import React, {useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import { PersonAdd } from '@material-ui/icons';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Modal, Grid } from '@material-ui/core';
import { loadUsers, setAirline, deleteUser, resetReqStatus } from '../../store/admin';
import StatusDisplay from "./StatusDisplay";
import AddUser from './modals/AddUserModal';
import EditUser from './modals/EditUserModal'
import styles from './styles'

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#e3e3e3',
    },
  },
}))(TableRow);

function createData(email, user_type, first_name, last_name, airline_id) {
  return { email, user_type, first_name, last_name, airline_id };
}

const ConfirmationModal = (props) => {
  const { handleDelete, classes, status } = props

  return (
    <Grid container justifyContent="center" className={classes.confirmationPaper} item xs={12}>
      <Grid container justifyContent="center" alignContent="center" item xs={12}>Are you sure you want to delete this user?</Grid>
      { !status ?
        <Grid container item xs={12}>
          <Grid item xs={3}></Grid>
          <Grid container justifyContent="center" alignContent="center" item xs={3}>
            <Button variant="contained" className={classes.confirmationBtn} style={{backgroundColor: '#63d563', margin: '8px'}} onClick={() => {handleDelete(false, true)}}>Yes</Button>
          </Grid>
          <Grid container justifyContent="center" alignContent="center" item xs={3}>
            <Button variant="contained" className={classes.confirmationBtn} style={{backgroundColor: '#d13939', margin: '8px'}} onClick={() => {handleDelete(false)}}>No</Button>
          </Grid>
        </Grid> :
        <Grid container item xs={12}>
          <Grid container justifyContent="center" alignContent="center" item xs={6}>
            <StatusDisplay status={status} />
          </Grid>
          <Grid container justifyContent="center" alignContent="center" item xs={6}>
            <Button variant="contained" className={classes.confirmationBtn} style={{backgroundColor: '#d13939', margin: '8px'}} onClick={() => {handleDelete(false)}}>Close</Button>
          </Grid>
        </Grid>
      }
    </Grid>
  )
}

export default function Admin(props) {
  const dispatch = useDispatch();
  const { userType, userAirline, isMobile, theme } = props
  const classes = styles(theme, isMobile);
  const [addUserModal, setAddUserModal] = React.useState(false);
  const [confirmation, setConfirmation] = React.useState(false)
  const [editUserModal, setEditUserModal] = React.useState(false)
  const [selectedUser, setUser] = React.useState({})
  const reqStatus = useSelector(state => state.entities.admin.reqStatus)
  
  useEffect(() => {
    dispatch(setAirline(userAirline))
    dispatch(loadUsers())
  }, []);
  
  const users = useSelector(state => state.entities.admin.users);
  let userTable = [];

  for (let i = 0; i < users.length; i++) {
    userTable.push(createData(
      users[i].email,
      users[i].user_type,
      users[i].first_name,
      users[i].last_name,
      users[i].airline_id
    ))
  }

  const handleAddUser = (bool) => {
    dispatch(resetReqStatus())
    setAddUserModal(bool)
  };

  const handleEditUser = (bool) => {
    dispatch(resetReqStatus())
    setEditUserModal(bool)
  }

  const handleConfirmation = (bool, confirmedDelete) => {
    if (bool === false && confirmedDelete === true) {
      dispatch(deleteUser(selectedUser))
    }
    else {
      dispatch(resetReqStatus())
      setConfirmation(bool)
    }
  }

  // TODO // Separate headers and rows into separate components
  return (
    <TableContainer>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell style={{ padding: '8px' }} align="center">Email</StyledTableCell>
            <StyledTableCell style={{ padding: '8px' }} align="center">User Type</StyledTableCell>
            <StyledTableCell style={{ padding: '8px' }} align="center">First name</StyledTableCell>
            <StyledTableCell style={{ padding: '8px' }} align="center">Last name</StyledTableCell>
            <StyledTableCell style={{ padding: '8px' }} align="center">Airline</StyledTableCell>
            <StyledTableCell style={{ padding: '8px' }} align="center"></StyledTableCell>
            <StyledTableCell style={{ padding: '8px' }} align="center"></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {userTable.map((row, index) => (
            <React.Fragment key={index}>
              <StyledTableRow key={index}>
                <StyledTableCell style={{ padding: '8px' }} component="th" scope="row" align="center">{row.email}</StyledTableCell>
                <StyledTableCell style={{ padding: '8px' }} align="center">{row.user_type}</StyledTableCell>
                <StyledTableCell style={{ padding: '8px' }} align="center">{row.first_name}</StyledTableCell>
                <StyledTableCell style={{ padding: '8px' }} align="center">{row.last_name}</StyledTableCell>
                <StyledTableCell style={{ padding: '8px' }} align="center">{row.airline_id}</StyledTableCell>
                <StyledTableCell style={{ padding: '8px' }} align="center">
                  <Button variant="contained" className={classes.editUserBtn} onClick={() => {setUser(row); handleEditUser(true)}}>Edit</Button>
                </StyledTableCell>
                <StyledTableCell style={{ padding: '8px' }} align="center">
                  <Button variant="contained" className={classes.deleteUserBtn} onClick={() => {setUser(row); handleConfirmation(true)}}>Delete</Button>
                </StyledTableCell>
              </StyledTableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
      <Button variant="contained" className={classes.addUserBtn} onClick={() => {handleAddUser(true)}}><PersonAdd /> Add new user</Button>
      <Modal
        open={addUserModal}
        onClose={() => {handleAddUser(false)}}
        className={classes.modal}
      >
        <AddUser userType={userType} userAirline={userAirline} handleClose={handleAddUser} status={reqStatus} />
      </Modal>
      <Modal
        open={confirmation}
        onClose={() => handleConfirmation(false)}
        className={classes.modal}
      >
        <ConfirmationModal handleDelete={handleConfirmation} classes={classes} status={reqStatus} />
      </Modal>
      <Modal
        open={editUserModal}
        onClose={() => setEditUserModal(false)}
        className={classes.modal}
      >
        <EditUser userType={userType} userAirline={userAirline} selectedUser={selectedUser} handleClose={setEditUserModal} status={reqStatus} />
      </Modal>
    </TableContainer>
  );
}